(() => {
  const SELECTOR = '[data-media-cards-section]';

  class MediaCards {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-media-cards-track]');
      this.prevButton = section.querySelector('[data-media-cards-prev]');
      this.nextButton = section.querySelector('[data-media-cards-next]');
      this.resizeObserver = null;

      if (!this.track) return;

      this.onTrackScroll = this.onTrackScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onMediaLoad = this.onMediaLoad.bind(this);

      this.init();
    }

    init() {
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.track);

      window.addEventListener('resize', this.onResize);
      this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
      this.prevButton?.addEventListener('click', this.onPrevClick);
      this.nextButton?.addEventListener('click', this.onNextClick);
      this.track.querySelectorAll('img').forEach((image) => {
        image.addEventListener('load', this.onMediaLoad, { once: true });
      });

      this.onResize();
      requestAnimationFrame(() => this.onResize());
      setTimeout(this.onResize, 250);
    }

    getScrollAmount() {
      const firstCard = this.track.querySelector('.media-cards__product-card');
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);

      return firstCard ? firstCard.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
    }

    onPrevClick() {
      this.track.scrollBy({
        left: -this.getScrollAmount(),
        behavior: 'smooth',
      });
    }

    onNextClick() {
      this.track.scrollBy({
        left: this.getScrollAmount(),
        behavior: 'smooth',
      });
    }

    onTrackScroll() {
      this.updateButtons();
    }

    updateButtons() {
      const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 1;
      const atStart = this.track.scrollLeft <= 1;
      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;

      if (this.prevButton) this.prevButton.disabled = !hasOverflow || atStart;
      if (this.nextButton) this.nextButton.disabled = !hasOverflow || atEnd;
    }

    onResize() {
      this.updateButtons();
    }

    onMediaLoad() {
      this.updateButtons();
    }

    destroy() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.onResize);
      this.track.removeEventListener('scroll', this.onTrackScroll);
      this.prevButton?.removeEventListener('click', this.onPrevClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
      this.track.querySelectorAll('img').forEach((image) => {
        image.removeEventListener('load', this.onMediaLoad);
      });
    }
  }

  const instances = new WeakMap();

  const initSections = (root = document) => {
    const sections = root.matches?.(SELECTOR) ? [root] : Array.from(root.querySelectorAll(SELECTOR));

    sections.forEach((section) => {
      if (!instances.has(section)) {
        instances.set(section, new MediaCards(section));
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => initSections());
  window.addEventListener('load', () => initSections());

  document.addEventListener('shopify:section:load', (event) => {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector(SELECTOR);
    const instance = section && instances.get(section);

    if (instance) {
      instance.destroy();
      instances.delete(section);
    }
  });
})();